import {
  CONFIRM_EMPLOYEE_PAGE_REQUEST,
  CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT,
  CONFIRM_EMPLOYEE_INVALID_INVITATION,
  CONFIRM_EMPLOYEE_SET_INVITED_EMPLOYEE
} from './constants'

export function pageRequest (params) {
  return {type: CONFIRM_EMPLOYEE_PAGE_REQUEST, payload: {params}}
}

export function setInvitedEmployee (invitedEmployee) {
  return {type: CONFIRM_EMPLOYEE_SET_INVITED_EMPLOYEE, payload: {invitedEmployee}}
}

export function createEmployeeAccount (data) {
  return {type: CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT, payload: {data}}
}

export function isInvalidInvitation (invalidInvitation) {
  return {type: CONFIRM_EMPLOYEE_INVALID_INVITATION, payload: {invalidInvitation}}
}



// WEBPACK FOOTER //
// ./app/actions/confirmEmployee/index.js